import { Controller } from "@hotwired/stimulus"

// Shows the message target when the wrapped access-level select is set to
// "contributor" and the member owns nothing (count value 0): they would be
// read-only until someone makes them a champion or team member.
export default class extends Controller {
  static targets = ["message"]
  static values = { count: Number }

  connect() {
    this.check()
  }

  check() {
    const select = this.element.querySelector("select")
    const readOnly = select?.value === "contributor" && this.countValue === 0
    this.messageTarget.classList.toggle("d-none", !readOnly)
    this.messageTarget.classList.toggle("d-flex", readOnly)
  }
}
